
const Css = {
  LeftDragBtn(left){
    return {
      width: "6px",
      height: "12px",
      borderTopLeftRadius: "4px",
      borderBottomLeftRadius: "4px",
      cursor: "e-resize",
      position: "absolute",
      left: left + "px",
      zIndex:2,
      transition: "all 0.05s linear", //渐变动画防止视觉卡顿
    }
  },
  img: {
    position: "absolute",
    height: "12px"
  }
}

export default Css;